<template>
  <Admin style="background: white">
    <v-main v-if="!isProductListLoading" class="wrapper">
      <v-container v-if="!selectedCompanyProductList?.isNsThaiSmartTax" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
        ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
          แบบแสดงรายการภาษีมูลค่าเพิ่ม
        </div>
        <v-divider/>
        <v-dialog v-model="pdfDialog">
          <div>
            <iframe :src="pdfSrc" class="iframe"></iframe>
          </div>
        </v-dialog>
        <v-card class="pa-4">
          <v-row>
            <v-col class="d-flex align-center" cols="5">
              <div >ยื่นแบบแสดงรายการโดย:</div>
            </v-col>
            <v-col cols="2">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  v-model="filterFetchData.submitType"
                  :items="submitTypeList"
                  class="input-boder"
                  dense
                  hide-details
                  label="ยื่นแบบ"
                  outlined
              ></v-select>
            </v-col>
          </v-row>

          <!-- {{ taxWHBranch.branch }} -->

          <v-row style="margin-top: -10px">
            <v-col class="d-flex align-center" cols="5">
              <div >สาขากิจการ:</div>
            </v-col>
            <v-col cols="2">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  v-model="filterFetchData.selectBranchId"
                  :disabled="isSubmitAll"
                  :items="taxWHBranch.branch"
                  class="input-boder"
                  dense
                  hide-details
                  item-disabled="disable"
                  item-text="code"
                  item-value="code"
                  label="เลือกสาขากิจการ"
                  outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: -10px">
            <v-col class="d-flex align-center" cols="5">
              <div >สถานะการยื่นแบบแสดงรายการ: </div>
            </v-col>
            <v-col cols="2">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="filterFetchData.submitStatus"
                  :items="submitStatusList"
                  class="input-boder"
                  dense
                  hide-details
                  label="สถานะการยื่น"
                  outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: -40px">
            <v-col cols="5">
              <v-checkbox
                  v-model="filterFetchData.additionalFilingStatus"
                  class="input-boder"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="within_time"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">ภายในกำหนดเวลา</span>
                  </template>
            </v-checkbox>
              <v-checkbox
                  v-model="filterFetchData.additionalFilingStatus"
                  dense
                  hide-details
                  style="margin-left: 0px; margin-top: -5px"
                  value="late_filing"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">เกินกำหนดเวลา</span>
                  </template>
            </v-checkbox>
            </v-col>
          </v-row>

          <v-row style="margin-top: -20px">
            <v-col class="d-flex align-center" cols="5">
              <div >เดือน-ปีที่ยื่นภาษี:</div>
            </v-col>
            <v-col cols="2">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  ref="selectMenu"
                  v-model="filterFetchData.selectedPeriod"
                  :items="hierarchicalPeriods"
                  dense
                  hide-details
                  item-text="name"
                  item-value="name"
                  label="เลือกเดือนที่ยื่นภาษี"
                  outlined
                  return-object
              >
                <template v-slot:item="{ item, props }">
                  <v-list-item
                      :class="getColorClass(item)"
                      :disabled="item.level === 0 || item.level === 1"
                      v-bind="props"
                      @click="handleTimePeriodSelectionAndCloseMenu(item)"
                  >
                    <v-list-item-title
                        :style="{
                        fontWeight: item.level === 0 ? 'bold' : 'normal',
                      }"
                    >
                      <span :style="{ 
                paddingLeft: `${item.level * 20}px`, 
                opacity: 1,
                color: item.level === 0 ? '#1976D2' : 'black',
                fontWeight: item.level === 0 ? 'bold' : 'normal'
              }">{{
                          item.name
                        }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: 10px">
            <v-col cols="5" class="tw-pr-0 tw-pt-0">
              <div  v-if="logsList.length > 0">
                <h1 class="tw-pb-2 tw-pt-4">ประวัติ</h1>
                <div class="tw-grid tw-grid-cols-10 tw-gap-2">
                  <div class="tw-w-"></div>
                <v-chip
                    v-for="log in logsList"
                    :key="log.index"
                    label
                    link
                    outlined
                    @click="openLogDetail(log)"
                    class="tw-p-0 t w-flex tw-justify-center"
                >
                  <span class="tw-text-center tw-w-full">{{ log.index}}</span>
                </v-chip>
                </div>
              </div>
            </v-col>
            <v-col cols="2">
              <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  block
                  class="white--text"
                  color="primary"
                  style="font-size: 14px"
                  @click="fetchTaxReport"
              >
                <template v-slot:default>
                  <v-icon left>mdi-download</v-icon>
                  ดึงข้อมูล
                </template>
              </v-btn>
            </v-col>
          </v-row>


          <v-dialog v-model="logDialog" max-width="480">
                    <v-card>
                      <div>
                        <v-sheet
                            class="tw-border tw-px-4 bg-gray-800 tw-rounded-xl py-4"
                            color="#f8f8f8"
                        >
                          <p class=" tw-font-bold text-center">History Log</p>
                          <div class="tw-max-w-xl tw-mx-auto">
                            <div class="tw-grid tw-gap-2">
                              <div class="tw-flex tw-justify-between">
                                <span>สร้างเมื่อ:</span>
                                <span>{{ getThaiDate(openLog?.createdAt) }}</span>
                              </div>
                              <div class="tw-flex tw-justify-between">
                                <span>status:</span>
                                <span>{{ openLog?.status }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>message:</span>
                                <span>{{ openLog?.message }}</span>
                              </div>


                              <div class="tw-flex tw-justify-between">
                                <span>ยื่นแบบแสดงรายการโดย:</span>
                                <span>{{ openLog?.taxReturnFilingOfBusiness }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>สถานะการยื่นแบบแสดงรายการ:</span>
                                <span>{{ openLog?.taxFilingStatus }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภายในกำหนดเวลา: </span>
                                <span>{{openLog?.chkIntime == 1}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>เกินกำหนดเวลา: </span>
                                <span>{{openLog?.chkOverdue == 1}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>เดือน-ปี:</span>
                                <span>{{ openLog?.taxPeriod }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีขาย (Output Tax):</span>
                                <span>{{ openLog?.outputTax }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีซื้อ (Input Tax):</span>
                                <span>{{ openLog?.["Input Tax"] }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีมูลค่าเพิ่ม (Value Added Tax):</span>
                                <span>{{ openLog?.["Value Added Tax"]}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีสุทธิ (Net Tax):</span>
                                <span>{{ openLog?.["Net Tax"]}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>เงินเพิ่ม (surcharge): </span>
                                <span>{{openLog?.["inCaseOfLateFilingAndPaymentOrAdditionalFiling"]}} </span>
                              </div>
                            </div>
                            <v-btn
                                block
                                color="primary"
                                elevation="0"
                                class="tw-mt-2"
                                :disabled="openLog?.percentage != 100"
                                @click="pdfSrc = openLog?.linkPdf, pdfDialog = true"
                            >
                              <v-icon class="tw-mr-2">mdi-eye</v-icon>
                              view PDF file</v-btn>
                          </div>
                        </v-sheet>
                      </div>
                    </v-card>
          </v-dialog>

          <v-divider class="tw-my-5"></v-divider>


          <!-- {{  valueAddedTaxReturnEachBranch}} -->
          <v-row class="text-row">
            <v-col cols="12">
              <p
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีขาย (Output Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col class="d-flex flex-column align-start" cols="5">
              <div class="label-text">1. ยอดขายในเดือนนี้</div>
              <div style="margin-top: -1px">
                กรณียื่นเพิ่มเติม
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L1SalesAmountThisMonth)
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="margin-top: -30px">
            <v-col cols="3">
              <v-checkbox
                  v-model="L1Checkbox"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="1.1"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">(1.1) ยอดขายแจ้งไว้ขาด</span>
                  </template>
            </v-checkbox>
              <v-checkbox
                  v-model="L1Checkbox"
                  dense
                  hide-details
                  style="margin-left: 0px; margin-top: -5px"
                  value="1.2"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">(1.2) ยอดซื้อแจ้งไว้เกิน</span>
                  </template>
            </v-checkbox>
            </v-col>
          </v-row>

          <v-row class="text-row" style="margin-top: -1px">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                2. ลบ ยอดขายที่เสียภาษีในอัตราร้อยละ 0 (ถ้ามี)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(
                    valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
                  )
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">3. ลบ ยอดขายที่ได้รับยกเว้น (ถ้ามี)</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L3LessExemptedSales)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                4. ยอดขายที่ต้องเสียภาษี (1.- 2. - 3.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L4TaxableSalesAmount)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">5. ภาษีขายเดือนนี้</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L5OutputTax)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีซื้อ (Input Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col class="d-flex flex-column align-start" cols="5">
              <div class="label-text">6. ยอดซื้อที่มีสิทธินําภาษีซื้อ</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L6PurchaseAmountThisMonth)
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="margin-top: -30px">
            <v-col cols="3" class="tw-pt-0">
              <v-checkbox
                  v-model="L6Checkbox"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="6.1"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">(6.1) ยอดซื้อแจ้งไว้ขาด</span>
                  </template>
            </v-checkbox>
              <v-checkbox
                  v-model="L6Checkbox"
                  dense
                  hide-details
                  style="margin-left: 0px; margin-top: -5px"
                  value="6.2"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">(6.2) ยอดขายแจ้งไว้เกิน</span>
                  </template>
            </v-checkbox>
            </v-col>
          </v-row>

          <v-row class="text-row" style="margin-top: -10px">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                7. ภาษีซื้อเดือนนี้ (ตามหลักฐานใบกํากับภาษีของยอดซื้อตาม 6.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L7InputTax)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  class="label-text"
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีมูลค่าเพิ่ม (Value Added Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col cols="5">
              <div class="label-text">
                8. ภาษีที่ต้องชําระเดือนนี้ (ถ้า 5. มากกว่า 7.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L8TaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                9. ภาษีที่ชําระเกินเดือนนี้ (ถ้า 5. น้อยกว่า 7.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L9ExcessTaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">10. ภาษีที่ชําระเกินยกมา</div>
            </v-col>
            <v-col cols="2">
              <template>
                <v-text-field
                    ref="L10Input"
                    v-model="L10ExcessTaxPaymentCarried"
                    class="text-field-style align-right"
                    dense
                    hide-details
                    hide-spin-buttons
                    outlined
                    placeholder="0.00"
                    type="number"
                ></v-text-field>
              </template>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  class="label-text"
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีสุทธิ (Net Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col cols="5">
              <v-checkbox
                  v-model="valueAddedTaxReturn.L11Checked"
                  dense
                  hide-details
                  :disabled='true'
              >
                <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px"
                  >11. ต้องชําระ (ถ้า 8. มากกว่า 10.)</span
                  >
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L11NetTaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <v-checkbox
                  v-model="valueAddedTaxReturn.L12Checked"
                  dense
                  hide-details
                  :disabled='true'
              >
                <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px"
                  >12. ชําระเกิน ((ถ้า 10. มากกว่า 8.) หรือ (9. รวมกับ
                    10.))</span
                  >
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L12NetExcessTaxPayable)
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  class="label-text"
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: 5px;
                  
                "
              >
                กรณียื่นแบบแสดงรายการและชําระภาษีเกินกําหนดเวลา
                หรือยื่นเพิ่มเติม (In case of late filing and payment , or
                additional filing)
              </p>
            </v-col>
          </v-row>

          <v-row class="text-row" style="margin-top: 5px">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">13. เงินเพิ่ม</div>
            </v-col>
            <v-col cols="2">
              <template>
                <v-text-field
                    v-model="L13Surcharge"
                    class="text-field-style align-right"
                    dense
                    hide-details
                    hide-spin-buttons
                    outlined
                    placeholder="0.00"
                    type="number"
                ></v-text-field>
              </template>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">14. เบี้ยปรับ</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-model="L14Penalty"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  hide-spin-buttons
                  outlined
                  placeholder="0.00"
                  type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                15. รวมภาษี เงินเพิ่ม และเบี้ยปรับที่ต้องชําระ ((11. + 13. +
                14.) หรือ (13. + 14. - 12.))
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L15TotalTaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                16. รวมภาษีที่ชําระเกิน หลังคํานวณเงินเพิ่มและเบี้ยปรับแล้ว (12.
                - 13. - 14.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L16TotalExcessTaxPayable)
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="7">
              <div class="tw-grid tw-grid-cols-2 tw-gap-3">
                <v-btn
                    :class="{ small: isSmallScreen }"
                    class="white--text"
                    color="primary"
                    @click="onClickPDF(selectedTaxWHCode)"
                >
                  <v-icon left>mdi-printer</v-icon>
                  | แบบแสดงรายการภาษีมูลค่าเพิ่ม (PDF)

                </v-btn>
                <!-- </v-col>
      <v-col cols="auto"> -->
                <v-btn
                    :class="{ small: isSmallScreen }"
                    class="white--text"
                    color="primary"
                    @click="onClickReport()"
                >
                  <v-icon left>mdi-printer</v-icon>
                  | ใบแนบ ภ.พ.30

                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            class="tw-text-center"
            timeout="2000"
            top
        >
          {{ snackbarText }}
        </v-snackbar>

<!--        <CircularProgress-->
<!--            ref="loadingSpinner"-->
<!--            :message="progress.message"-->
<!--            :percentage="progress.percentage"-->
<!--            :showTrigger="false"-->
<!--            :size=300-->
<!--            overlayPosition="bottom"-->
<!--            @visibility-change="onVisibilityChange"-->
<!--        />-->
      </v-container>
    </v-main>
    <v-main v-else>
      <div class="tw-flex tw-justify-center tw-mt-20">
        <!-- <v-progress-circular
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular> -->
      </div>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
// import CircularProgress from '@/components/public/circular-progress.vue';
import fc from "@/firebaseConfig";
import isMobile from "../../libs/detectMobile";
import firebase from "firebase/app";
import "firebase/auth";
import {mapState} from "vuex";
import {getCurrentPeriodMonth, getHierarchicalPeriods,} from "@/libs/getPerioid";

const _ = require("lodash");
const axios = require("axios");
const moment = require("moment");

const periods = getHierarchicalPeriods(2023, new Date().getFullYear());
const currentPeriod = getCurrentPeriodMonth(periods);
export default {
  data() {
    return {
      isLoading: false,
      pdfDialog: false,
      pdfSrc: "",
      //
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",

      submitTypeList: ["ยื่นรวม", "ยื่นแยก"],
      submitStatusList: [
        "ยื่นปกติ",
        "ยื่นเพิ่มเติมครั้งที่ 1",
        "ยื่นเพิ่มเติมครั้งที่ 2",
      ],
      hierarchicalPeriods: periods,

      //
      filterFetchData: {
        submitType: "ยื่นรวม",
        selectBranchId: "",
        submitStatus: "ยื่นปกติ", // ยื่นปกติ, ยื่นเพิ่มเติมครั้งที่ 1, ยื่นเพิ่มเติมครั้งที่ 2
        additionalFilingStatus: "", // in_time, late_filing
        selectedPeriod: currentPeriod.name,
        selectedTimePeriod: currentPeriod,
      },
      isSmallScreen: false,

      L1Checkbox: "", // "1.1" or "1.2"
      L6Checkbox: "", // "6.1" or "6.2"
      L10ExcessTaxPaymentCarried: "0.00",
      L13Surcharge: "0.00",
      L14Penalty: "0.00",
      progress: {
        status: '',
        message: '',
        percentage: 0,
      },
      isGenerating: false,
      jobId: "",
      unsubscribeProgress: null,
      isPdfAlreadyGenerated: false,


      logsList: [],
      logsListUnsubscribe: null,
      openLog: null,
      logDialog: false
    };
  },
  name: "TaxReport",
  components: {
    Admin,
  },
  created() {
    this.getTaxWHBranch();
    this.fetchLog();
  },

  computed: {
    ...mapState({
      selectedCompanyProductList: (state) =>
          state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
      taxWHBranch: (state) => state.thaismartTax.taxWHBranch,
      valueAddedTaxReturn: (state) =>
          state.thaismartTaxDetail.valueAddedTaxReturn,
      valueAddedTaxReturnEachBranch: (state) =>
          state.thaismartTaxDetail.valueAddedTaxReturnEachBranch,
      // companyDetail:(state) =>state.companies.companyDetail
    }),
    isSubmitAll() {
      return this.filterFetchData.submitType === "ยื่นรวม";
    },
  },
  watch: {
    filterFetchData: {
      handler: function (val, oldVal) {
        if (val.submitType === "ยื่นรวม") {
          this.filterFetchData.selectBranchId = "";
        }
        this.fetchLog()
      },
      deep: true,
    },
    L10ExcessTaxPaymentCarried: {
      handler: function () {
        // toFixed(2)
        this.calculatedValueAddedTaxReturn();
      },
    },
    L13Surcharge: {
      handler: function () {
        this.calculatedValueAddedTaxReturn();
      },
    },
    L14Penalty: {
      handler: function () {
        this.calculatedValueAddedTaxReturn();
      },
    },
    jobId: {
      handler: function () {
        if (this.jobId && this.isGenerating) {
          this.watchProgress();
        }
      },
    },
  },
  methods: {
    getThaiDate(timestamp) {
      if (!timestamp) return "N/A";
      moment.locale("th");

      const date = new Date(timestamp.seconds * 1000);

      // Format the date with Thai month and Buddhist year
      const formattedDate = moment(date).format("hh:mm DD/MM/YYYY");

      return formattedDate;
    },

    // onVisibilityChange(visible) {
    //   this.isGenerating = visible;
    // },

    getColorClass(item) {
      if (item.type === "quarter") {
        return "bg-quarter";
      } else if (item.type === "year") {
        return "";
      }
      return "";
    },

    updateScreenSize() {
      this.isSmallScreen = window.innerWidth < 600;
    },

    handleTimePeriodSelectionAndCloseMenu(item) {
      this.filterFetchData.selectedTimePeriod = item;
      this.filterFetchData.selectedPeriod = item.name;
      // this.handleSelection(item);
      this.$refs.selectMenu.blur();
    },

    async onClickPDF(selectedTaxWHCode) {
      console.log("this is TaxWHCode :", selectedTaxWHCode);
      console.log("this is periods :", this.selectedPeriod);
      try {
        // this.$store.dispatch("setGlobalLoading", true);
        this.downloadPdfLoading = true;
        this.pdfSrc = null;
        console.log("selectedTaxWHCode", selectedTaxWHCode);
        // if (!['1', '2'].includes(selectedTaxWHCode)) {
        //   throw new Error("Invalid tax code selected");
        // }

        let data;
        if (["1", "2"].includes(selectedTaxWHCode)) {
          console.log("selectedStartDate", this.selectedStartDate);
          console.log("selectedEndDate", this.selectedEndDate);
          data = this.valueAddedTaxReturnEachBranch;
        }
        if (
            this.displayAmount(
                this.valueAddedTaxReturn.L1SalesAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L3LessExemptedSales) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L4TaxableSalesAmount) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L5OutputTax) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L6PurchaseAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L7InputTax) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L8TaxPayable) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L9ExcessTaxPayable) ===
            "0.00" &&
            this.displayAmount(this.L10ExcessTaxPaymentCarried) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L11NetTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L12NetExcessTaxPayable
            ) === "0.00" &&
            this.displayAmount(this.L13Surcharge) === "0.00" &&
            this.displayAmount(this.L14Penalty) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L15TotalTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L16TotalExcessTaxPayable
            ) === "0.00"
        ) {
          this.snackbar = true;
          this.snackbarColor = "#FFCA28";
          this.snackbarText = "ไม่พบข้อมูล";
          return;
        }

        let type =
            selectedTaxWHCode === "1" || selectedTaxWHCode === "2"
                ? selectedTaxWHCode
                : undefined;

        // this.initProgress()
        this.$store.dispatch("setGlobalLoading", true);
        const result = await this.updateWHIncomeTaxReturn(data, "1");
        /* 
          {
              "success": true,
              "linkPdf": "https://firebasestorage.googleapis.com/v0/b/sld-etax.appspot.com/o/%2FDTRnq2huePWrzlqVh3KxdHp6W383%2FCompanies%2FqCp8p3s5hafVuAOBmutT%2FSettingThaiSmartTax%2F%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B9%81%E0%B8%AA%E0%B8%94%E0%B8%87Tax.pdf?alt=media&token=DTRnq2huePWrzlqVh3KxdHp6W383",
              "downloadToken": "DTRnq2huePWrzlqVh3KxdHp6W383"
          }
          */
        const link = result?.linkPdf;
        if (result?.isGenerated) {
          this.progress = {
            message: "PDF already generated, displaying",
            percentage: 90,
            status: "completed"
          }
        }

        if (!link) {
          throw new Error("PDF link not found");
        }

        console.log("link:: ", link);

        if (!this.pdfDialog && link) {
          const response = await axios
              .get(link, {
                responseType: "arraybuffer",
              }).catch(console.error);

          let url = URL.createObjectURL(
              new Blob([response.data], {type: "application/pdf"})
          );

          if (isMobile()) {
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "wht" + new Date().getTime() + ".pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.pdfSrc = url;
            this.pdfDialog = true;
          }
          // this is where to open progress
        }
      } catch (error) {
        console.error("Error in onClickWHT:", error);
        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = `${error.message}`;
      } finally {
        this.$store.dispatch("setGlobalLoading", false);
        // this.completeProgress()
        this.downloadPdfLoading = false;
        this.selectedPeriod = null;
        this.selectedStartDate = null;
        this.selectedEndDate = null;
      }
    },

    onClickReport: async function (selectedTaxWHCode) {
      try {
        this.$store.dispatch("setGlobalLoading", true);
        this.downloadPdfLoading = true;
        this.pdfSrc = null;
        let data;
        if (["1", "2"].includes(selectedTaxWHCode)) {
          data = this.valueAddedTaxReturnEachBranch;
        }

        if (
            this.displayAmount(
                this.valueAddedTaxReturn.L1SalesAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L3LessExemptedSales) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L4TaxableSalesAmount) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L5OutputTax) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L6PurchaseAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L7InputTax) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L8TaxPayable) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L9ExcessTaxPayable) ===
            "0.00" &&
            this.displayAmount(this.L10ExcessTaxPaymentCarried) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L11NetTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L12NetExcessTaxPayable
            ) === "0.00" &&
            this.displayAmount(this.L13Surcharge) === "0.00" &&
            this.displayAmount(this.L14Penalty) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L15TotalTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L16TotalExcessTaxPayable
            ) === "0.00"
        ) {
          this.snackbar = true;
          this.snackbarColor = "#FFCA28";
          this.snackbarText = "ไม่พบข้อมูล";
          return;
        }

        let type =
            selectedTaxWHCode === "1" || selectedTaxWHCode === "2"
                ? selectedTaxWHCode
                : undefined;

        const result = await this.updateAttReport(data, "1");
        //console.log("🚀 ~ result:", result);
        const link = result?.linkPdf;

        if (!link) {
          throw new Error("PDF link not found");
        }

       // console.log("link:: ", link);

        if (!this.pdfDialog && link) {
          await axios
              .get(link, {
                responseType: "arraybuffer",
              })
              .then(
                  (response) => {
                    this.downloadPdfLoading = false;

                    let url = URL.createObjectURL(
                        new Blob([response.data], {type: "application/pdf"})
                    );

                    if (isMobile()) {
                      let a = document.createElement("a");
                      document.body.appendChild(a);
                      a.style = "display: none";
                      a.href = url;
                      a.download = "wht" + new Date().getTime() + ".pdf";
                      a.click();
                      window.URL.revokeObjectURL(url);
                    } else {
                      this.pdfSrc = url;
                      this.pdfDialog = true;
                    }
                  },
                  (error) => {
                    console.log(error);
                  }
              );
        }
      } catch (error) {
        //console.error("Error in onClickWHT:", error);
        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = `${error.message}`;
      } finally {
        this.downloadPdfLoading = false;
        this.selectedPeriod = null;
        this.selectedStartDate = null;
        this.selectedEndDate = null;
        this.$store.dispatch("setGlobalLoading", false);
      }
    },

    updateWHIncomeTaxReturn: async function (paramdata, type) {
      // if (!paramdata) {
      //   return;
      // }
      // get user token
      let token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false)
          .then(function(idToken){
            return idToken
          })

      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      // console.log(paramdata);
      // console.log("taxWHBranch", this.taxWHBranch);
      // console.log("selectBranchId", this.filterFetchData.selectBranchId);
      let branchCode =
          this.filterFetchData.selectBranchId === ""
              ? "00000"
              : this.filterFetchData.selectBranchId;

      const companydetail = this.taxWHBranch?.branch?.find(
          (branch) => branch.code == branchCode
      );
      // console.log("companydetail", companydetail);
      // console.log('this is periode', Months);
      //  console.log("filterFetchData",this.filterFetchData)
      let data = {
        companyID: this.$route.params.companyId,
        type: type, // 1=WHT53 ,2=WHT3 , 3=ATT53 , 4=ATT3
        jobId: this.jobId,
        data: {
          valueAddedTaxReturnEachBranch: this.valueAddedTaxReturnEachBranch,
          items: [],
          companyDetail: {...companydetail},
          "@Pdftax": "gs://sld-etax.appspot.com/NsPDF/tax.pdf",
          submitStatus: this.filterFetchData.submitStatus,
          submitType: this.filterFetchData.submitType,
          selectedPeriod: this.filterFetchData.selectedPeriod,
          additionalFilingStatus: this.filterFetchData.additionalFilingStatus,
          L1Checkbox: this.L1Checkbox,
          L6Checkbox: this.L6Checkbox,
          L11Checked: this.valueAddedTaxReturn.L11Checked,
          L12Checked: this.valueAddedTaxReturn.L12Checked,
          checkbox: {
            "fillingInTime": this.filterFetchData.additionalFilingStatus === "in_time" ? true : false,
            "fillingLate": this.filterFetchData.additionalFilingStatus === "late_filing" ? true : false,
            "neitherInTimeNorLate": this.filterFetchData.additionalFilingStatus === "" ? true : false,
            "L1.1": this.L1Checkbox === "1.1" ? true : false,
            "L1.2": this.L1Checkbox === "1.2" ? true : false,
            "neither1.1Nor1.2": this.L1Checkbox === "" ? true : false,
            "L6.1": this.L6Checkbox === "6.1" ? true : false,
            "L6.2": this.L6Checkbox === "6.2" ? true : false,
            "neither6.1Nor6.2": this.L6Checkbox === "" ? true : false,
          },
          L1SalesAmountThisMonth: this.displayAmount(
              this.valueAddedTaxReturn.L1SalesAmountThisMonth
          ),
          L2LessSalesSubjectToZeroTaxRate: this.displayAmount(
              this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
          ),
          L3LessExemptedSales: this.displayAmount(
              this.valueAddedTaxReturn.L3LessExemptedSales
          ),
          L4TaxableSalesAmount: this.displayAmount(
              this.valueAddedTaxReturn.L4TaxableSalesAmount
          ),
          L5OutputTax: this.displayAmount(this.valueAddedTaxReturn.L5OutputTax),
          L6PurchaseAmountThisMonth: this.displayAmount(
              this.valueAddedTaxReturn.L6PurchaseAmountThisMonth
          ),
          L7InputTax: this.displayAmount(this.valueAddedTaxReturn.L7InputTax),
          L8TaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L8TaxPayable
          ),
          L9ExcessTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L9ExcessTaxPayable
          ),
          L10ExcessTaxPaymentCarried: this.displayAmount(
              this.L10ExcessTaxPaymentCarried
          ),
          L11NetTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L11NetTaxPayable
          ),
          L12NetExcessTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L12NetExcessTaxPayable
          ),
          L13Surcharge: this.displayAmount(this.L13Surcharge),
          L14Penalty: this.displayAmount(this.L14Penalty),
          L15TotalTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L15TotalTaxPayable
          ),
          L16TotalExcessTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L16TotalExcessTaxPayable
          ),
        },
      };
      // console.log("data", data);

        const promise = new Promise((resolve, reject) => {
        //const baseUrl = "http://localhost:5001/sld-etax/us-central1/";
        const baseUrl = fc.cloudFunctionUrl;
        const endpoint = "updateTaxIncomeReturn"; // ใช้ path ที่ต้องการเพิ่ม

        axios.post(baseUrl + endpoint, data, {headers}).then(
            (response) => {
              if (response.status === 200) {
                resolve(response.data);
              }
            },
            (error) => {
              reject(error);
              console.log(error);
              this.$store.dispatch("setGlobalLoading", false);
              this.downloadPdfLoading = false;
            }
        );
      });
      return promise;
    },

    updateAttReport: async function (paramdata, type) {
      if (!paramdata && paramdata?.lenght < 0) {
        return;
      }

      // get user token
      let token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false)
          .then(function (idToken) {
            return idToken;
          });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let branchCode =
          this.filterFetchData.selectBranchId === ""
              ? "00000"
              : this.filterFetchData.selectBranchId;
      const companydetail = this.taxWHBranch?.branch?.find(
          (branch) => branch.code == branchCode
      );
      // console.log('this is periode', Months);
      //console.log(this.valueAddedTaxReturnEachBranch);


      let data = {
        companyID: this.$route.params.companyId,
        type: type, // 1=WHT53 ,2=WHT3 , 3=ATT53 , 4=ATT3
        // jobId: jobId,
        // companyDetail: {...companydetail },
        data: {
          items: this.valueAddedTaxReturnEachBranch.map((value) => {
            return {
              submitStatus: this.filterFetchData.submitStatus,
              selectedPeriod: this.filterFetchData.selectedPeriod,
              L4TaxableSalesAmount: this.displayAmount(
                  value.value.L4TaxableSalesAmount
              ),
              L5OutputTax: this.displayAmount(value.value.L5OutputTax),
              L6PurchaseAmountThisMonth: this.displayAmount(
                  value.value.L6PurchaseAmountThisMonth
              ),
              L7InputTax: this.displayAmount(value.value.L7InputTax),
              L8TaxPayable: this.displayAmount(value.value.L8TaxPayable),
              L9ExcessTaxPayable: this.displayAmount(
                  value.value.L9ExcessTaxPayable
              ),
              L11NetTaxPayable: this.displayAmount(
                  value.value.L11NetTaxPayable
              ),
              L12NetExcessTaxPayable: this.displayAmount(
                  value.value.L12NetExcessTaxPayable
              ),
              companyDetail: {...companydetail},
            };
          }),
          selectedPeriod: this.filterFetchData.selectedPeriod,
          submitStatus: this.filterFetchData.submitStatus,
          companyDetail: {...companydetail },
          "@Reporttax": "gs://sld-etax.appspot.com/NsPDF/attachment.pdf",
        },
      };
      // console.log(data);

      const promise = new Promise((resolve, reject) => {
      //const baseUrl = "http://localhost:5001/sld-etax/us-central1/";
      const baseUrl = fc.cloudFunctionUrl;
        const endpoint = "updateReportTax"; // ใช้ path ที่ต้องการเพิ่ม

        axios
            .post(
              baseUrl+endpoint,
                data,
                {headers}
            )
            .then(
                (response) => {
                  if (response.status === 200) {
                    resolve(response.data);
                  }
                },
                (error) => {
                  reject(error);
                  console.log(error);
                  this.$store.dispatch("setGlobalLoading", false);
                  this.downloadPdfLoading = false;
                }
            );
      });
      return promise;
    },

    getTaxWHBranch: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store
            .dispatch("thaismartTax/fetchTaxWHBranch", {companyId: companyId})
            .then(() => {
              this.filterFetchData.selectedBranchId =
                  this.taxWHBranch?.branch[0].code || null;
            })
            .catch((error) => {
              console.error("Error fetching branches:", error);
            });
      }
    },

    calculatedValueAddedTaxReturn() {
      this.$store.dispatch("thaismartTaxDetail/calculateTaxAddedValueReturn", {
        L1Checkbox: this.L1Checkbox,
        L6Checkbox: this.L6Checkbox,
        L10ExcessTaxPaymentCarried: this.L10ExcessTaxPaymentCarried,
        L13Surcharge: this.L13Surcharge,
        L14Penalty: this.L14Penalty,
      });
    },
    async fetchTaxReport() {
      this.isLoading = true;
      await this.$store.dispatch("thaismartTaxDetail/fetchSubmitDocsList", {
        companyId: this.$route.params.companyId,
        submitPeriod: this.filterFetchData.selectedTimePeriod.name,
        branchId: this.filterFetchData.selectBranchId,
      });
      this.L10ExcessTaxPaymentCarried = "0.00";
      this.L13Surcharge = "0.00";
      this.L14Penalty = "0.00";
      this.L1Checkbox = "";
      this.L6Checkbox = "";
      this.calculatedValueAddedTaxReturn();
      this.isLoading = false;
    },
    displayAmount(amount) {
      if (typeof amount === "number") {
        return amount?.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }
      return amount;
    },
    onClickPP30() {
      this.calculatedValueAddedTaxReturn();
      console.log("onClickPP30", this.valueAddedTaxReturn); // contain all 16 fields and 2 checkbox(L1Checkbox, L6Checkbox)
    },
    onClickAttachPP30() {
      console.log("onClickAttachPP30");
    },
    async initProgress() {
      this.isGenerating = true;
      this.progress = {
        status: 'Started',
        message: '',
        percentage: 0,
      };

      this.$refs.loadingSpinner.show();
      this.jobId = window.crypto.randomUUID();
    },
    completeProgress(msg = '') {
      this.unsubscribeProgress();
      if (msg) {
        this.progress.message = msg;
      }
      this.isGenerating = false;
      this.progress = {
        status: 'completed',
        message: 'Completed',
        percentage: 100,
      };
      this.$refs.loadingSpinner.hide();
      this.jobId = '';
    },
    async watchProgress() {
      const period = this.filterFetchData.selectedTimePeriod.name.split(' ').join('') || '';
      const companyID = this.$route.params.companyId; // Replace with actual company ID
      const docPath = `Companies/${companyID}/reportThaiSmartTax/valueAddedTaxReturnPDF/${period}/${this.jobId}`;
      if (this.unsubscribeProgress) {
        this.unsubscribeProgress();
      }
      console.log('watch log:', this.jobId);
      this.unsubscribeProgress = fc.db.doc(docPath).onSnapshot(
          (doc) => {
            if (doc.exists && !this.isPdfAlreadyGenerated) {
              const data = doc.data();
              this.progress = {
                status: data.status,
                message: data.message,
                percentage: data.percentage,
              };
            }
          },
          (error) => {
            console.error("Error fetching document:", error);
          }
      );
    },
    async fetchLog() {
      const period = this.filterFetchData.selectedTimePeriod.name.split(' ').join('') || '';
      const companyID = this.$route.params.companyId; // Replace with actual company ID
      const logCol = await fc.db.collection(`Companies/${companyID}/reportThaiSmartTax/valueAddedTaxReturnPDF/${period}`).get();

      let logs = logCol.docs.map(doc => doc.data());

      logs = logs.filter(log => log.taxReturnFilingOfBusiness === this.filterFetchData.submitType);

      if (this.filterFetchData.additionalFilingStatus) {
        logs = logs.filter(log =>
            this.filterFetchData.additionalFilingStatus === "within_time" ? log.chkIntime === 1 : log.chkOverdue === 1
        );
      }

      if (this.filterFetchData.submitStatus) {
        logs = logs.filter(log => log.taxFilingStatus === this.filterFetchData.submitStatus);
      }

      if (this.filterFetchData.selectBranchId && this.filterFetchData.submitType === "ยื่นแยก") {
        logs = logs.filter(log => log.subsidiariesBranch === this.filterFetchData.selectBranchId);
      }

      logs.sort((a, b) => a.createdAt.seconds - b.createdAt.seconds);

      this.logsList = logs.map((log, index) => ({
        id: log.id,
        doc: log,
        index: index + 1,
      }));
    },
    openLogDetail(log) {
      this.openLog = log.doc
      this.logDialog = true
    },
  },
};
</script>

<style lang="css" scoped>
.span-w {
  width: 100px;
}

.table-container {
  padding: 1rem;
}

table {
  width: 100%;
  table-layout: fixed;
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.text-field-style {
  .v-input {
    text-align: right !important;
  }

  
}

.bg-quarter{
  background-color:#B2DFDB ;
}


.align-right >>> input {
  text-align: right;
  padding-top: 14px;
}
</style>
